<template>
    <div
        class="flex justify-center items-center text-red my-4"
        v-if="!!message"
    >
        <img v-if="showImage" :src="failImg" class="w-10 mr-2" />
        <span class="mt-1">
            {{ $t(message) }}
        </span>
    </div>
</template>

<script>
import img3s112 from '../assets/img/3-112.png';

export default {
    props: {
        message: { type: String },
        showImage: { type: Boolean, default: false }
    },
    data: () => ({
        failImg: img3s112
    })
};
</script>
